import script from "./AppSideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSideBar.vue?vue&type=script&lang=ts&setup=true"

import "./AppSideBar.vue?vue&type=style&index=0&id=73944653&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73944653"]])

export default __exports__